export default __webpack_public_path__ + "static/media/DW1.d26cf921.png";